var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilter = function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M16.352 7.459a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0m1.428.75a3.901 3.901 0 0 1-7.656 0H3.78a.75.75 0 1 1 0-1.5h6.344a3.901 3.901 0 0 1 7.656 0h2.44a.75.75 0 0 1 0 1.5zM12.452 17.252a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0m1.428.75a3.901 3.901 0 0 1-7.656 0H3.78a.75.75 0 0 1 0-1.5h2.444a3.901 3.901 0 0 1 7.656 0h6.34a.75.75 0 1 1 0 1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFilter;